@charset "UTF-8";

/* src/app/app.component.scss */
.right {
  position: absolute;
  top: 0.5vh;
  right: 1vw;
}
.left {
  position: absolute;
  top: 0.2vh;
  left: 1vw;
  padding-right: 2vw;
}
.left2 {
  position: absolute;
  top: 0.4vh;
  left: 4vw;
}
:host ::ng-deep .ef-custom-icon {
  display: inline-block;
  width: 2.5rem;
  height: 2.5rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
:host ::ng-deep .ef-leave-request-icon {
  background-image: url("./media/palm_tree_icon_v2.png");
}
.floating-expert-launcher-cluster {
  position: fixed;
  right: 4rem;
  bottom: 7rem;
  z-index: 10050;
}
.floating-expert-dismiss {
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(calc(-100% + 0.62rem), calc(-100% + 0.62rem));
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50% 50% 5% 50%;
  border: 0;
  padding: 0;
  background: var(--surface-600, #575757);
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  z-index: 1;
}
.floating-expert-dismiss:hover {
  filter: brightness(1.04);
}
@keyframes floating-expert-border-shimmer {
  to {
    transform: rotate(360deg);
  }
}
@keyframes floating-expert-border-glow {
  0%, 100% {
    opacity: 0.88;
  }
  50% {
    opacity: 1;
  }
}
.floating-expert-launcher {
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
  border: 0;
  background: transparent;
  color: var(--primary-color-text);
  box-shadow: none;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.22));
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  isolation: isolate;
  overflow: visible;
}
.floating-expert-launcher::before {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  background:
    conic-gradient(
      from 0deg,
      var(--p-emerald-500, #10b981),
      color-mix(in srgb, var(--p-emerald-500, #10b981) 55%, var(--p-yellow-400, #facc15)),
      var(--p-yellow-400, #facc15),
      color-mix(in srgb, var(--p-yellow-400, #facc15) 50%, var(--p-primary-500, #337AB7)),
      var(--p-primary-500, #337AB7),
      color-mix(in srgb, var(--p-primary-500, #337AB7) 55%, var(--p-emerald-500, #10b981)),
      var(--p-emerald-500, #10b981));
  animation: floating-expert-border-shimmer 10s linear infinite, floating-expert-border-glow 4s ease-in-out infinite;
  z-index: -2;
}
.floating-expert-launcher::after {
  content: "";
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: var(--p-surface-700);
  z-index: -1;
}
.floating-expert-launcher img {
  position: relative;
  z-index: 1;
}
.floating-expert-launcher:hover {
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.22)) brightness(1.08);
}
.floating-expert-launcher:hover::before {
  animation-duration: 7s, 3s;
}
@media (prefers-reduced-motion: reduce) {
  .floating-expert-launcher::before {
    animation: none;
    background: var(--p-emerald-500, #10b981);
  }
}
.floating-expert-panel {
  position: fixed;
  right: 2.5rem;
  bottom: 5.3rem;
  width: min(30rem, calc(100vw - 5rem));
  height: min(52rem, calc(100vh - 6.8rem));
  min-width: 18rem;
  min-height: 14rem;
  max-width: calc(100vw - 5rem);
  max-height: calc(100vh - 6.8rem);
  z-index: 10040;
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
  background: var(--surface-card);
  box-shadow: 0 12px 40px color-mix(in srgb, var(--text-color) 14%, transparent);
  overflow: hidden;
  display: none;
}
.floating-expert-panel--open {
  display: block;
}
.floating-expert-panel-resize-handle {
  position: absolute;
  width: 14px;
  height: 14px;
  z-index: 2;
  touch-action: none;
}
.floating-expert-panel-resize-handle--nw {
  top: 0;
  left: 0;
  cursor: nwse-resize;
}
.floating-expert-panel-resize-handle--ne {
  top: 0;
  right: 0;
  cursor: nesw-resize;
}
.floating-expert-panel-resize-handle--sw {
  bottom: 0;
  left: 0;
  cursor: nesw-resize;
}
.floating-expert-panel-resize-handle--se {
  bottom: 0;
  right: 0;
  cursor: nwse-resize;
}
:host ::ng-deep .floating-expert-panel .chat-shell {
  height: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
}
/*# sourceMappingURL=app.component.css.map */
